export enum DEVICE_TYPE_LINEAR_RANGE_ENUM {
  LACTATE_A_SLOPE_MIN = 0.5,
  LACTATE_A_SLOPE_MAX = 1.5,
  LACTATE_B_OFFSET_MIN = -1,
  LACTATE_B_OFFSET_MAX = 1,
  POWER_A_SLOPE_MIN = 0.75,
  POWER_A_MAX = 1.25,
  POWER_B_OFFSET_MIN = -20,
  POWER_B_OFFSET_MAX = 20,
  GPS_A_SLOPE_MIN = 0.9,
  GPS_A_SLOPE_MAX = 1.1,
  GPS_B_OFFSET_MIN = 0,
  GPS_B_OFFSET_MAX = 100,
  VO2_A_SLOPE_MIN = 0.8,
  VO2_A_SLOPE_MAX = 1.2,
  VO2_B_OFFSET_MIN = -300,
  VO2_B_OFFSET_MAX = 300,
  VCO2_A_SLOPE_MIN = 0.8,
  VCO2_A_SLOPE_MAX = 1.2,
  VCO2_B_OFFSET_MIN = -300,
  VCO2_B_OFFSET_MAX = 300,
}
